import { Close, UploadFile } from '@mui/icons-material'
import { Box, Button, CircularProgress, Dialog, IconButton } from '@mui/material'
import { Download } from '../../../../core/transmit/S3';
import Currency from 'react-currency-format';
import moment from 'moment'

export const View = ({openView, paidView, subdir}) => {
    const tblStyles = {flex: 1, whiteSpace: 'noWrap', p: 1, overflow: 'hidden', textOverflow: 'ellipsis'}
    const h = [  subdir === 'booking' ? 'Booking No.' : 'Order No.', subdir === 'booking' ?  'Date of Booking' : 'Date of Order', 'Sales Amount', 'Ref No.', 'Payment Method', 'Fee', 'Net Amount']
    return (
        <Dialog open={openView.data} onClose={() => openView.set(false)}
            PaperProps={{ 
                sx:{ height:  { sm: '70vh', md: '80vh', lg: '90vh' }, maxHeight: { sm: '70vh', md: '80vh', lg: '90vh' }, 
                     width: { sm: '100vh', md: '110vh', lg: '120vh' }, maxWidth: { sm: '100vh', md: '110vh', lg: '120vh' } } 
            }} >
            <Box p="24px" display="flex" flexDirection="column" gap="16px" height="100%" width="100%">
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box component="b" fontSize={24}>Payment Details</Box>
                    <IconButton onClick={() => openView.set(false)}>
                        <Close />
                    </IconButton>
                </Box>
                {
                    paidView.data.loader ?
                        <Box height="100%" width="100%" display="flex" alignItems="center" justifyContent="center">
                            <CircularProgress />
                        </Box>
                    :
                        <>
                            <Box display="flex" alignItems='center' bgcolor="#f2f2f2" borderBottom="1px solid #ddd">
                                {
                                    h.map((v,k)  => (
                                        <Box sx={tblStyles} component="b" fontSize={14} key={k}>
                                            {v}
                                        </Box>
                                    ))
                                }
                            </Box>
                            <Box height="100%" width="100%" display="flex" flexDirection="column" className="overflowY">
                                {
                                    paidView.data.list.map((v,k) => (
                                        <Box display="flex" alignItems="center" bgcolor="#fff" borderBottom="1px solid #ddd" fontSize={14} key={k}>
                                            {console.log(v)}
                                            <Box sx={tblStyles}>
                                                {v.series_num}
                                            </Box>
                                            <Box sx={tblStyles}>
                                                {moment(v.created_at).format('MM/DD/YYYY')}
                                            </Box>
                                            <Box sx={tblStyles}>
                                                <Currency value= {v.amount} displayType={'text'} thousandSeparator={true} prefix={''} />
                                            </Box>
                                            <Box sx={tblStyles}>
                                                {v.reference_number}
                                            </Box>
                                            <Box sx={tblStyles}>
                                                {v.payment_channel_id === 15 ? 'UnionBank' : 'Gcash'}
                                            </Box>
                                            <Box sx={tblStyles}>
                                                {v.payment_fee}
                                            </Box>
                                            <Box sx={tblStyles}>
                                                <Currency value={(v.amount - v.payment_fee).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} />
                                            </Box>
                                        </Box>
                                    ))
                                }
                            </Box>
                            <Box display="flex" justifyContent="flex-end">
                                <Box display="flex" flexDirection="column" component="b" gap="8px">
                                    <Box display="flex" justifyContent="space-between" gap="32px">
                                        <Box>Total Sales</Box>
                                        <Currency value={paidView.data.total_sales} displayType={'text'} thousandSeparator={true} prefix={''} />
                                    </Box>
                                    <Box display="flex" justifyContent="space-between" gap="32px">
                                        <Box >Less Total Fees</Box>
                                        <Currency value={paidView.data.total_fees} displayType={'text'} thousandSeparator={true} prefix={''} />
                                    </Box>
                                    <Box display="flex" justifyContent="space-between" gap="32px">
                                        <Box>Less Payment Transfer</Box>
                                        <Currency value={paidView.data.transfer_charges} displayType={'text'} thousandSeparator={true} prefix={''} />
                                    </Box>
                                    <Box display="flex" justifyContent="space-between" gap="32px">
                                        <Box>Total Net Amount</Box>
                                        <Currency value={paidView.data.total_net_amount} displayType={'text'} thousandSeparator={true} prefix={''} />
                                    </Box>
                                </Box>
                            </Box>
                            <Box display="flex" flexDirection="column" gap="8px" component="b">
                                <Box>Merchant Bank Details:</Box>
                                <Box display="flex" alignItems="center" gap="24px">
                                    <Box>Bank Name:</Box>
                                    <Box>{paidView.data.bank_name}</Box>
                                </Box>
                                <Box display="flex" alignItems="center" gap="24px">
                                    <Box>Bank Account No.:</Box>
                                    <Box>{paidView.data.account_number}</Box>
                                </Box>
                                <Box display="flex" alignItems="center" gap="24px">
                                    <Box>Payment Reference No.:</Box>
                                    <Box>{paidView.data.payment_reference_number}</Box>
                                </Box>
                                <Box display="flex" alignItems="center" gap="24px">
                                    <Box component="b">Upload File</Box>
                                    <Button component="label" onClick={(e) => Download(e, paidView.data.link, paidView.data.name)}>
                                        <UploadFile sx={{fontSize: 60}} />
                                        <Box>{paidView.data.name}</Box>
                                    </Button>
                                </Box>
                            </Box>
                        </>
                }
            </Box>
        </Dialog>
    )
}
